<div
  class="op-ian-relative-time"
  [title]="fixedTime"
  [textContent]="relativeTime$ | async">
</div>
